module.exports = __webpack_public_path__ + "static/img/guard_title.5078405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_title.png
// module id = g5Qk
// module chunks = 0